/**
 * Btn — kit button. Ported from design/project/lib/ns-kit.jsx; pixel
 * values live in the .ns-btn classes in index.css.
 */
import type { ButtonHTMLAttributes } from "react";

export type BtnVariant = "primary" | "secondary" | "ghost" | "outline" | "danger";
export type BtnSize = "sm" | "md" | "lg";

export interface BtnProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: BtnVariant;
  size?: BtnSize;
  full?: boolean;
}

export function Btn({
  children,
  variant = "secondary",
  size = "md",
  full = false,
  className,
  ...rest
}: BtnProps) {
  const cls = [
    "ns-btn",
    `ns-btn--${variant}`,
    size !== "md" ? `ns-btn--${size}` : "",
    full ? "ns-btn--full" : "",
    className ?? "",
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <button type="button" {...rest} className={cls}>
      {children}
    </button>
  );
}
